//@flow

import styled from "styled-components"

export const Container = styled.div`
  background: #0c5897;
  height: 100%;
  width: 100%;
  position: relative;
`

export const Toolbar = styled.ul`
  list-style: none;
  margin: none;
  display: flex;
  flex-direction: row;
  margin: 0;
  padding: 0;
  position: absolute;
  z-index: 1;
  bottom: 8px;
  width: 100%;
  left: 0;
`

export const ToolbarItem = styled.li`
  list-style: none;
  margin: 0 5px;
  &:first-child {
    margin-left: auto;
  }
  &:last-child {
    margin-right: auto;
  }
`

export const ToolbarButton = styled.button`
  background: transparent;
  border: none;
  padding: 0;
  height: 230px;
  width: 236px;
  position: relative;
  margin: auto;
  transform: rotate(${props =>
    props.selected ? -23 : 0}deg) translate(0, ${props =>
  props.selected ? -12 : 0}px));
`

export const ContentWindow = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  width: 100%;
  height: 762px;
  z-index: 0;
`

export const TitleText = styled.h1`
  text-transform: uppercase;
  color: #25beae;
  font-family: "din-condensed";
  font-size: 200px;
  text-shadow: 3px 3px 3px rgba(0, 0, 0, 0.35);
  margin: 0;
  line-height: 1em;
`

export const TitleDescription = styled.p`
  font-size: 36px;
  color: #132048;
  margin: 0;
  padding: 0 0.5rem;
  font-family: "din-condensed";
  text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff,
    1px 1px 0 #fff, 0px 0px 10px #fff;
`



// WEBPACK FOOTER //
// ./src/Kiosk/CommitView/UI.js